// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getProp } from "@insite/mobius/utilities";
import buttonStyle from "@steiner/XDL/PreStyle/button";
import { color } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

const subscribeHubspotForm = css`
    .hs-form-private {
        position: relative;
        display: grid;
        grid-template-columns: 1fr 1fr auto;
        grid-template-rows: 1fr auto;
        gap: 0;
        grid-template-areas:
            "Input Input Submit"
            "Error-Message Error-Message Error-Message";
        font-family: "Arial", sans-serif;

        .hs-error-msg,
        .hs-error-msgs label {
            color: ${color("danger")};
            font-size: 14px;
            font-weight: normal;
            letter-spacing: 0;
            line-height: 22px;
        }

        .hs-email.hs-form-field {
            color: ${color("common.white")};
            grid-area: Input;

            & > label {
                display: none;
            }

            & > .input {
                height: 36px;
                display: flex;
                align-items: center;
                width: 100%;
                border: 1px solid ${color("common.ui5")};
                background-color: ${color("common.ui16")};
                box-shadow: inset 0 1px 0 0 ${color("common.black", 0.1)};
                border-right-width: 0;

                input {
                    width: 100%;
                    height: 100%;
                    background-color: ${color("common.ui16")};
                    padding: 0 9px;
                    &,
                    &:focus,
                    &:focus-within {
                        border: none;
                        outline: none;
                    }

                    &::placeholder {
                        font-style: italic;
                        color: ${color("common.ui4")};
                    }
                }
            }
        }

        .hs-submit {
            grid-area: Submit;
            display: flex;
            justify-content: flex-end;
            height: 36px;
            padding: 4px 5px 0;
            border: 1px solid ${color("common.ui5")};
            background-color: ${color("common.ui16")};
            box-shadow: inset 0 1px 0 0 ${color("common.black", 0.1)};
            border-left-width: 0;
            flex-shrink: 0;

            .hs-button {
                padding: 0 20px;
                background: ${color("common.ui8")};
                border: 2px solid ${color("common.ui8")};
                min-height: 28px;
                ${buttonStyle.primary.css}
                cursor: pointer;
                transition: all ${getProp("theme.transition.duration.regular")}ms ease-in-out;
                color: ${color("common.white")};
                line-height: 12px;
                font-size: 12px;
                font-weight: bold;
                letter-spacing: 0;
                text-align: center;
            }
        }

        .hs_error_rollup {
            grid-area: Error-Message;
        }
    }
`;

export default subscribeHubspotForm;
